import Vue from 'vue';
import VueRouter from 'vue-router';
import Indice from '@/views/Indice.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/:language',
    name: 'Indice',
    component: Indice,
  },
  {
    path: '/:language/:producto/:modelo',
    name: 'Configurator',
    // route level code-splitting
    // this generates a separate chunk (Configurator.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Configurator" */ '@/views/Configurator.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.params.language) {
    return next({ path: '/es', replace: true });
  }

  store.commit('setLanguage', to.params.language);
  next();
});

export default router;
